import { apiRoutes } from '@features/campaigns/details/consts/apiRoutes.ts';
import { OneflightBody, OneflightParams } from '@features/campaigns/details/shared/types/oneFlight.ts';
import { apiClient } from '@shared/api/ApiClient.ts';

export async function exportOneFlight({ campaignId, brandId }: OneflightParams): Promise<OneflightBody | null> {
  return await apiClient.post(apiRoutes.exportOneflight(campaignId), { brandId });
}
